export enum AlertType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export const NOTIFICATION_DURATIONS = {
  SHORT: 2000,
  DEFAULT: 3000,
  LONG: 5000,
} as const
